import TestQues from "container/testTemp/testQues/testQues";
import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import placeholderIcon from "../../../../assets/img/placeholderIcon.png";
import "./multiTap.scss";

export default function MultiTap({ question, what }) {
  const [selectedAns, setSelectedAns] = useState([]);

  useEffect(() => {
    if (what === "actualAns") {
      const choiceArr = question.correct_choice.split(",");
      setSelectedAns([...choiceArr]);
    }
    if (what === "userAns") {
      if (question.user_answer.length > 30) {
        const choices = [
          question.choice_1,
          question.choice_2,
          question.choice_3,
          question.choice_4,
          question.choice_5,
          question.choice_6,
        ];

        const userAns = !!question.user_answer
          ? question.user_answer.split(",")
          : [];
        let myUserAns = [];
        userAns &&
          userAns.forEach((userAns) => {
            const found = choices.findIndex(
              (choice) => choice.trim() === userAns.trim()
            );
            myUserAns = [...myUserAns, found.toString()];
          });

        setSelectedAns(myUserAns);
      } else {
        const choiceArr = !question.user_answer
          ? []
          : question.user_answer.split(",");
        setSelectedAns([...choiceArr]);
      }
    }
  }, [question, what]);

  const isActive = (choice) => {
    if (selectedAns.includes(choice)) {
      return "active";
    } else {
      return "";
    }
  };

  const isText = question.test_format === "text_match_scroll";

  const userChoice = (number, choice) => {
    console.log("datadata");
    return (
      <>
        {choice && (
          <div
            className={`multi-tap-ques-img-choice ${isActive(number)}`}
            style={{ justifySelf: "center" }}
          >
            {isText ? (
              <h2 style={{ margin: 0 }}>{choice}</h2>
            ) : (
              <LazyLoadImage
                placeholderSrc={placeholderIcon}
                alt=""
                effect="blur"
                src={choice}
              />
            )}
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div data-aos="zoom-in" className="test-body-content">
        {what === "actualAns" || what === "userAns" ? (
          <div
            className=""
            style={{
              display: "grid",
              // gridTemplateColumns:"",
              // gridTemplateColumns: "auto auto auto",
              // flexWrap: "wrap",
              // justifyContent: "center",
              // alignItems: "center",

              // fixed grid style
              gridTemplateColumns: "repeat(auto-fit,minmax(120px,150px))",
              width: "100%",
              justifyContent: "center",
            }}
          >
            {userChoice("1", question.choice_1)}
            {userChoice("2", question.choice_2)}
            {userChoice("3", question.choice_3)}
            {userChoice("4", question.choice_4)}
            {userChoice("5", question.choice_5)}
            {userChoice("6", question.choice_6)}
            {userChoice("7", question.choice_7)}
            {userChoice("8", question.choice_8)}
            {userChoice("9", question.choice_9)}
            {userChoice("10", question.choice_10)}
            {userChoice("11", question.choice_11)}
            {userChoice("12", question.choice_12)}
          </div>
        ) : (
          <TestQues type="visualKeypad" question={question} />
        )}
      </div>
    </>
  );
}
